import { Grid, Stack, Title, useMantineTheme } from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'

import {
  Collection as CollectionType,
  Product as ProductType,
  Showcase as ShowcaseType,
  Site as SiteType,
  Store as StoreType
} from '@/types'

import ProductCard from './ProductCard'

interface Props {
  site?: SiteType
  store?: StoreType
  showcase?: ShowcaseType
  collections: CollectionType[]
  products: ProductType[]
}

export default function SinglePageCollectionsDisplay({
  site,
  store,
  showcase,
  collections,
  products
}: Props) {
  // Hooks
  const theme = useMantineTheme()
  const isSm = useMediaQuery(`(max-width: ${theme.breakpoints.sm}px)`)

  // Constants
  const showListMode = products?.length <= 4 && !isSm
  const gridSizes = showListMode
    ? { span: 12, md: products?.length === 1 ? 12 : 6 }
    : { span: 12, xs: 6, md: 4, lg: 12 / 5 }

  return (
    <Stack>
      {Array.isArray(collections) &&
        !!collections?.length &&
        collections?.map(collection => (
          <Stack mb="xl" key={collection.uid}>
            <Title>{collection.displayName}</Title>
            {Array.isArray(products) && !!products?.length && (
              <Grid gutter="lg">
                {products
                  .filter((product: any) => product.collection.uid === collection.uid)
                  .map((product: any) => (
                    <Grid.Col key={product?.uid} {...gridSizes}>
                      <ProductCard
                        product={product}
                        site={site}
                        store={store}
                        showcase={showcase}
                        showListMode={showListMode}
                      />
                    </Grid.Col>
                  ))}
              </Grid>
            )}
          </Stack>
        ))}
    </Stack>
  )
}
